<template>
    <div class="input-container" ref="inputMain">
		<transition name="fade">
			<div v-show="emotionfag">
				<emotion @selectimg="selectimg"/>
			</div>
		</transition>
		<transition name="fade">
			<div v-show="fontfag">
				<font  @changestyle="changestyle"/>
			</div>
		</transition>
		<div class="emotionbar-main" v-show="customerState == 2">
			<div class="emotionbar">
				<div>
					<span class="specialFont" @click.stop="hidefont">
					</span>
				</div>
				<div>
					<span class="emotion1" @click.stop="hideemontion" unselectable="on" onmousedown="return false;">
					</span>
				</div>
				<div>
					<span class="picture">
						<input type="file" ref="pictureFrom" name="file" @change="fileChange" accept="image/gif,image/jpeg,image/jpg,image/png">
					</span>
				</div>
			</div>
		</div>
		<div class="input-main">
			<div
				ref="edit"
				:class="`edit needsclick ${placeholder}`"
				draggable="false"
				placeholder="有问题就尽管提问吧"
				:contenteditable="true"
				@keyup="editChange"
				@input="editChange"
				@focus="onFocus"
				@blur="onBlur"
				:text="txt"
				@keydown.enter.prevent ="sendMsg"
				:style="fontstyle"
			>
			</div>
			<div v-show="customerState !== 2 && similarObj.list.length > 0 && similarObj.key.length > 0" class="similarList" ref="similarList">
			  <div
				v-for="(item, index) in similarObj.list"
				:key="index"
				v-html="transColor(similarObj.key,item.QuestionContent || item)"
				@click="askRobot(item)">
				</div>
			</div>
			<transition name="feedback">
			<div v-show="feedbackObj" class="feedbackBtns">
				<span v-for="item in feedBackOpts" :key="item.key" @click="feedback(item)">{{item.val}}</span>
			</div>
			</transition>
			<button class="over"  @click="overMsg">结束</button>
			<button class="send" :disabled="isDisabled" @click="sendMsg">发送</button>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
import utils from '../utils/util'
import emotion from './templates/emotion'
import font from './templates/font'
export default {
	name: "mobile-input",
	props:['emotionfag','fontfag'],
	components:{
		emotion,font
	},
	data() {
		return {
			txt: "",
			isFocus: false,
			iosFocus: false,
			showTip: true,
			feedBackOpts: [{
				key: 1,
				val: '有帮助'
			// },{
			// 	key: 2,
			// 	val: '你理解错了'
			// },{
			// 	key: 3,
			// 	val: '答案不清楚'
			},{
				key: 4,
				val: '转人工'
			}],
			hasLine: 1,
			scrollTimer: null,
			maxHeight: 0,
			fontstyle:{},
		}
	},
	methods: {
		selectimg(val){
			this.insertText(`<img src='./static/emotion_qq/${val.fileName}' data-code=${val.code}>`);
			this.txt = this.filterimg($('.edit').html()).replace(/">/g,'')
		},
		 changestyle(val){
			 this.fontstyle = val
		 },
		insertText(text) {
			var obj = $('.edit')[0];
			var range, node;
			if (!obj.hasfocus) {
				obj.focus();
			}
			if (document.selection && document.selection.createRange) {
				$('.edit').focus();
				document.selection.createRange().pasteHTML(text);
				$('.edit').focus();
			} else if (window.getSelection && window.getSelection().getRangeAt) {
				range = window.getSelection().getRangeAt(0);
				range.collapse(false);
				node = range.createContextualFragment(text);
				var c = node.lastChild;
				range.insertNode(node);
				if (c) {
					range.setEndAfter(c);
					range.setStartAfter(c)
				}
				var j = window.getSelection();
				j.removeAllRanges();
				j.addRange(range);
				$('.edit').focus();
			}
		},
		hideemontion(){     //父子通信 告诉父组件需要展示表情框
			if(this.emotionfag){
				this.$emit('hidefag', false)
			}else{
				this.$emit('hidefag', true)
			}
		},
		hidefont(){     //父子通信 告诉父组件需要展示表情框
			if(this.fontfag){
				this.$emit('hidefag1', false)
			}else{
				this.$emit('hidefag1', true)
			}
		},
		size () {
			return {
				width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
				height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
			}
		},
		fileChange(e) {
            window.$el = e;
            console.log(e.target.files[0])

            var file = e.target.files[0]
            if(file.size < Math.pow(1024, 2)){
                Bus.$emit("sendImage", e.target.files[0]);
            }else{
                const name = file.name; //文件名
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    const src = e.target.result;
                    const img = new Image();
                    img.src = src;
                    img.onload = (e) => {
                        const w = img.width;
                        const h = img.height;
                        const quality = 0.92;  // 默认图片质量为0.92
                        //生成canvas
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                        // 创建属性节点
                        const anw = document.createAttribute("width");
                        anw.nodeValue = w;
                        const anh = document.createAttribute("height");
                        anh.nodeValue = h;
                        canvas.setAttributeNode(anw);
                        canvas.setAttributeNode(anh);

                        //铺底色 PNG转JPEG时透明区域会变黑色
                        ctx.fillStyle = "#fff";
                        ctx.fillRect(0, 0, w, h);

                        ctx.drawImage(img, 0, 0, w, h);
                        // quality值越小，所绘制出的图像越模糊
                        const base64 = canvas.toDataURL('image/jpeg', quality); //图片格式jpeg或webp可以选0-1质量区间

                        // 返回base64转blob的值
                        console.log(`原图${(src.length/1024).toFixed(2)}kb`, `新图${(base64.length/1024).toFixed(2)}kb`);
                        //去掉url的头，并转换为byte
                        const bytes = window.atob(base64.split(',')[1]);
                        //处理异常,将ascii码小于0的转换为大于0
                        const ab = new ArrayBuffer(bytes.length);
                        const ia = new Uint8Array(ab);
                        for (let i = 0; i < bytes.length; i++) {
                            ia[i] = bytes.charCodeAt(i);
                        }
                        file = new Blob( [ab] , {type : 'image/jpeg'});
                        file.name = name;
                        console.log(file)
                        Bus.$emit("sendImage",file);
                        // success(file);
                    }
                    img.onerror = (e) => {
                        error(e);
                    }
                }
                reader.onerror = (e) => {
                    error(e);
                }
            }




			// Bus.$emit("sendImage", e.target.files[0]);
		},
		editChange(e) {
      this.txt = this.filterfag(this.filterimg($(e.target).html()))
		},
		onFocus(e) {
			this.isFocus = true;
			if (this.$Native.isAndroid()) {
				this.scrollTimer = setInterval(() => {
				this.$refs.inputMain.scrollIntoViewIfNeeded();
				}, 300)
			}
			// swiper.allowTouchMove = false
		},
		onBlur(e) {
			this.isFocus = false;
			if (!this.txt.trim()) {
				this.txt = "";
				this.$refs.edit.innerText = "";
			}
			this.scrollTimer && clearInterval(this.scrollTimer)
      // swiper.allowTouchMove = true;
		},
		sendMsg(e) {
			if (this.txt.length == 0) {
				this.$toast("请输入内容")
				return;
			}
			if (this.txt.length > 300) {
				this.$toast("请不要发送超过300字")
				return;
			}
			if (this.txt === "njtest-pppppp") {
				Bus.$emit("openDebug")
			} else {
				Bus.$emit("sendText", this.txt);
				 if(this.customerState == 2){
					 Bus.$emit("sendInputMsgToCustomer", '', "zxkf_002", 200);
				 }
			}
			this.$nextTick(() => {
				Bus.$emit("msgListScrollToEnd");
			})
			this.txt = "";
			this.$refs.edit.innerText = "";
		},
		overMsg(){
			Bus.$emit("triggerFeedconfirm",()=>{},123456)
		},
		feedback(obj) {
			Bus.$emit("robotFeedback", {
				FeedbackType: 1,
				FeedbackResult: obj.key,
			}, this.feedbackObj)
		},
		transColor(key, val) {
			var content = val;
			for (let obj of key) {
				content = content.replace(obj, `<span class='keyword'>${obj}</span>`);
			}
			return content;
			// return val.replace(key, `<span class='keyword'>${key}</span>`)
		},
		askRobot(item) {
			logger("askRobot", item)
			this.txt = "";
			this.$refs.edit.innerText = "";
			this.$store.commit("m_similar_obj",{key: '', list:[]});
			Bus.$emit("sendText", item);
		},
		filterimg(html){
			const regExp = /(<img).*?(data-code=")/g;
			return html.replace(regExp,'')
		},
		filterfag(html){
			return html.replace(/<\/?.+?>/g,"").replace(/ /g,"").replace(/("style).*?(">)/g,'').replace(/">/g,'')
		}
	},
	watch: {
		customerState(val) {
			if (val === 2) {
				setTimeout(() => {
				  this.showTip = false
				}, 3000)
			}
		},
		txt(val) {
			var self = this;
			if (this.customerState !== 2) {
				// searchSimilarQuestion(() => {
				//     Bus.$emit("getSimilarQuestion1", val)
				// })
			}else{
				 Bus.$emit("sendInputMsgToCustomer", val, "zxkf_002", 200);
			}
			if (this.$refs.edit.offsetHeight > 36) {
				this.hasLine = 2;
			} else {
				this.hasLine = 1;
			}
		},
		hasLine(val) {
			this.$emit("lineChange", val)
		}
	},
    computed: {
      ...mapGetters({
        initStatus: 'initStatus',
        customerState: 'customerState',
        feedbackObj: 'feedbackObj',
        similarObj: 'similarObj'
        }),
        placeholder() {
          return !this.txt.trim() && !this.isFocus ? "placeholder" : "";
        },
        isDisabled() {
          return !this.initStatus || !this.txt.trim();
        }
    },
    mounted() {
      this.maxHeight = document.body.scrollTop;
    }
	}

	var searchSimilarQuestion = utils.debounce((cb) => {
	cb && cb()
	}, 100)

</script>

<style>
  .input-container {
	position: absolute;
    bottom: 100px;
	right: 0px;
	left: 20px;
    zoom: 1;
    text-align: left;
    z-index: 12;
    height: auto;
  }


.input-main {
	display: flex;
	padding-top: 0;
	align-items: flex-end;
	position: relative;
	width: 100%;
	box-sizing: border-box;
	text-align: left;
}

.edit {
	background-color: #fff;
	height: 100px;
	overflow: auto;
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 0%;
	overflow-x: hidden;
	line-height: 20px;
	box-sizing: border-box;
	border: 1px solid #cccccc;
	/* border-radius: 50px; */
	outline: none;
	user-select: text;
	padding: 5px 15px;
	vertical-align: bottom;
  -ms-line-height:40px;
  -webkit-user-modify: read-write-plaintext-only;
}

.edit[contenteditable='false'] {
  background-color: #efefef;
}

.edit.placeholder:after{
  display: inline-block;
  width: 100%;
  color: #999;
  content: attr(placeholder);
}
.over{
	border: 1px solid #ccc;
	color: #5E5E5E;
	background-color: #fff;
	position: absolute;
	right: 100px;
	bottom: 10px;
	padding: 2px 10px;
	height: 26px;
	cursor: pointer;
}
.send {
  height: 26px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 54px;
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
  background-color: #ff4400;
  color: #ffffff;
	border: 1px solid #ff4400;
	position: absolute;
	right: 30px;
	bottom: 10px;
	padding: 2px 10px;
}

.send[disabled] {
	border: 1px solid #ccc;
	color: #5E5E5E;
	background-color: #fff;
	position: absolute;
	right: 30px;
	bottom: 10px;
	padding: 2px 10px;
}

.imgInput {
  margin-left: 5px;
  width: 35px;
  box-sizing: border-box;
  padding: 7px;
  position: relative;
  background-color: #ccc;
  border-radius: 50%;
  overflow: hidden;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 35px;
}

.imgInput img{
  width: 100%;
}

.msg-tip {
  position: absolute;
  font-size: 14px;
  width: 150px;
  text-align: center;
  right: 5px;
  top: -25px;
  z-index: 100;
  transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  background-color: #FF7747;
  line-height: 30px;
  color: #fff;
  border-radius: 15px;
  z-index: 1000;
}

.msg-tip:after {
  content: '';
  position: absolute;
  display: block;
  border-top: 5px solid #FF7747;
  border-bottom: 5px solid transparent;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
}

.imgInput input {
  display: block;
  height: 100%;
  width: 100%;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.feedbackBtns,
.similarList{
  position: absolute;
  bottom: 55px;
  font-size: 14px;
  color: #FF6434;
  z-index: 999;
}

.feedbackBtns {
    left: 0;
    right: 0;
    padding-left: 10px;
    padding: 5px;
    /* background: #eee; */
    bottom: 47px;
}

.feedbackBtns>span {
  padding: 5px 10px;
  margin-right: 10px;
  border-radius: 3px;
  background-color: #F6E6E1;
  cursor: pointer;
}
.feedbackBtns>span:hover{
	opacity: 0.8;
}
.similarList {
  left: 0;
  right: 0;
  bottom: 46px;
  z-index: 1000;
  width: 100%;
  background-color: #fff;
  border: 1px solid #EEEEEE;
}

.similarList>div{
  width: 100%;
  color: #000;
  line-height: 40px;
    text-indent: 1em;
  /* padding: 0 10px; */
}
.similarList>div:hover{
	background: #ffefdb;
}
.keyword {
  color: #FF4400;
}
.emotionbar-main{
	display: flex;
	padding-top: 5px;
	position: relative;
	width: 100%;
}
.emotionbar{
	background-color: #edf5f8;
	width: 100%;
	height: 27px;
	position: relative;
}
.emotion1{
	background: url(../assert/allbgs.png) no-repeat 0px -108px;
	height: 20px;
	width:20px;
	display: inline-block;
	margin: 4px;
	cursor: pointer;
	position: absolute;
    top: 0px;
    left: 32px;
}
.picture{
	background: url(../assert/allbgs.png) no-repeat 0px -74px;
	height: 17px;
	width:20px;
	display: inline-block;
	margin: 4px;
	cursor: pointer;
	position: absolute;
    top: 2px;
    left: 64px;
}
.specialFont{
	background: url(../assert/allbgs.png) no-repeat 0px -57px;
	height: 17px;
	width:20px;
	display: inline-block;
	margin: 6px 4px;
	cursor: pointer;
	position: absolute;
	top: 0px;
    left: 0;
}
/* .file{
	background: url(../assert/allbgs.png) no-repeat 0px -91px;
	height: 17px;
	width:20px;
	display: inline-block;
	margin: 6px 4px;
	cursor: pointer;
} */
.emotionbar>div{
	display: inline-block;
}

.picture input{
	width: 20px;
	box-sizing: border-box;
	position: relative;
	background-color: #ccc;
	overflow: hidden;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 35px;
	opacity: 0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to  {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/PcInput.vue